(function () {
    'use strict';

    angular
        .module('assets.mybimiboo.com')
        .directive('myTable', function ($parse) {
            return {
                restrict: 'E, A, C',
                link: function (scope, element, attrs) {
                    if (!scope.options.id) {
                        scope.options.id = uuidv4();
                    }

                    var dataTable = element.dataTable(scope.options);
                    scope[scope.options.id] = dataTable;

                    element.on('click', 'tr', function () {
                        if (scope.options.onItemClick) {
                            var rowData = dataTable.api().row($(this)).data();
                            scope.options.onItemClick(rowData);
                        };
                    });
                },
                scope: {
                    options: "="
                }
            };
        });

})();